/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiDomainResponseFromJSON, ApiDomainResponseToJSON, } from './ApiDomainResponse';
export function ApiReadDomainResponseFromJSON(json) {
    return ApiReadDomainResponseFromJSONTyped(json, false);
}
export function ApiReadDomainResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'domain': !exists(json, 'domain') ? undefined : ApiDomainResponseFromJSON(json['domain']),
    };
}
export function ApiReadDomainResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'domain': ApiDomainResponseToJSON(value.domain),
    };
}
